import axios from "axios"
import OPTS from './options'

const ax = axios.create({
    baseURL: OPTS.api_url,
    responseType: 'json',
    responseEncoding: 'utf8',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
    }
});

const API = {
    async search(parameters) {
        let res = await ax.post(`/search`, parameters);

        return res.data;
    }
};

export default API;